
import EmojiSelector from "@/components/chat/input/EmojiSelector"
import Button from "@/components/base/Button"
import { mdiSend } from "@mdi/js"

export default {
    name: "MentionableInput",
    components: { Button, EmojiSelector },
    props: {
        input: {
            type: String,
            required: true,
        },
        mentionableData: {
            type: Array,
            required: true,
        },
        inputRules: {
            type: Array,
            required: false,
        },
        messageError: {
            type: String,
            required: true,
        },
        messageState: {
            type: String,
            required: true,
        },
        mentionLength: {
            type: Number,
            required: false,
            default: 15,
        },
        sendAction: {
            type: Function,
            required: true,
        },
        mentionableFilter: {
            type: Function,
            required: false,
            default: (item, queryText) => {
                const mentionRegex = /@(\w+)?/gi
                const mentionablePattern = queryText.match(mentionRegex, "$1")
                if (mentionablePattern && mentionablePattern.length > 0) {
                    const menionableName = mentionablePattern[
                        // always suggest entities for the last @<text>
                        mentionablePattern.length - 1
                    ].replace(mentionRegex, "$1")
                    return (
                        item.text
                            .toLocaleLowerCase()
                            .indexOf(menionableName.toLocaleLowerCase()) > -1
                    )
                }
                return false
            },
        },
    },
    data: () => {
        return {
            mdiSend,
            showMentionableMenu: false,
            emojiMenu: false,
            entityMentioned: false,
            mentionedEntityText: "",
            mentionPosition: 0,
            message: "",
            cursorPosition: 0,
            emojiFilter: "",
            showError: false,
        }
    },
    computed: {
        filteredMentionableEntities() {
            return this.mentionableData.filter((item) =>
                this.mentionableFilter(item, this.message)
            )
        },
    },
    watch: {
        message: function (newVal, oldVal) {
            // Emoji detection
            if (Math.abs(newVal.length - oldVal.length) <= 1) {
                let index = this.currCursorPosition()
                let char = newVal[index - 1]
                if (char == ":" && newVal.length > oldVal.length) {
                    this.emojiMenu = !this.emojiMenu
                    this.cursorPosition = index
                }
                if (char == " ") {
                    this.emojiMenu = false
                }
                if (this.emojiMenu) {
                    let emoji = []
                    // Serach for previous ':' before current cursor index
                    for (const c of [...newVal].slice(0, index).reverse()) {
                        if (c == ":") {
                            break
                        }
                        if (c == " ") {
                            emoji = []
                        }
                        emoji.unshift(c)
                    }
                    this.emojiFilter = emoji.join("").replace(" ", "")
                }
            } else {
                this.emojiMenu = false
            }

            // By Roman
            if (newVal.slice(-1) === "@") {
                // user wants to mention something and the menu should pop up
                if (
                    !this.entityMentioned &&
                    (oldVal.slice(-1) === " " || oldVal.length === 0)
                ) {
                    this.mentionPosition = newVal.length
                    this.showMentionableMenu = true
                }
            }
            // user enters a whitespace and cancels the mentioning process
            else if (this.showMentionableMenu && newVal.slice(-1) === " ") {
                this.showMentionableMenu = false
            }
            // user deleted everything
            else if (newVal.length === 0) {
                this.resetMention()
            }
            // user deletes the mention
            else if (
                this.mentionedEntityText.length > 0 &&
                oldVal.includes(this.mentionedEntityText) &&
                !newVal.includes(this.mentionedEntityText)
            ) {
                this.message = oldVal.replace(this.mentionedEntityText, "")
                this.resetMention()
            }
            this.$emit("input-changed", newVal)
        },
    },
    mounted() {
        this.message = this.input
    },
    methods: {
        resetState() {
            this.resetMention()
            this.message = ""
        },
        resetMention() {
            this.entityMentioned = false
            this.mentionedEntityText = ""
            this.mentionedEntityValue = ""
            this.showMentionableMenu = false
        },
        sendMessage() {
            this.sendAction()
            this.resetState()
            this.emojiFilter = ""
        },
        handleInput(val) {
            if (val) {
                this.emojiFilter = null
            }
        },
        selectMention(entity) {
            this.showMentionableMenu = false

            const entityText =
                entity.text.length > 12
                    ? `${entity.text.substring(0, 12)}...`
                    : entity.text

            this.mentionedEntityText = `@${entityText}`

            let afterText = this.message.slice(this.mentionPosition)
            const beforeText = this.message.slice(0, this.mentionPosition)
            if (afterText.indexOf(" ") === -1) {
                afterText = this.mentionedEntityText.slice(1)
            }
            this.message = `${beforeText}${afterText}`
            this.showMentionableMenu = false
            this.entityMentioned = true
            this.mentionedEntityValue = entity.value
            this.$emit("entity-mentioned", {
                ...entity,
                entityText: this.mentionedEntityText,
            })
            this.$refs.input.focus()
        },
        currCursorPosition() {
            const textarea = this.$refs.input.$refs.input
            let pos = textarea.selectionStart
            if (pos === undefined) {
                pos = 0
            }
            return pos
        },
        addEmoji(emoji) {
            const insertText = `:${emoji.name}:`
            if (!insertText.length) return
            const textarea = this.$refs.input.$refs.input
            const sentence = textarea.value
            const len = sentence.length
            let remove = this.emojiFilter?.length ?? 0
            if (this.emojiFilter === "") {
                remove = 1
            } else if (this.emojiFilter === null) {
                remove = 0
            } else if (this.emojiFilter) {
                remove++
            }
            const before = sentence.substr(0, this.cursorPosition - remove)
            const after = sentence.substr(this.cursorPosition, len)
            this.message = before + insertText + " " + after

            this.$nextTick(() => {
                textarea.focus()
                let cPos = this.cursorPosition + insertText.length - remove + 1
                textarea.setSelectionRange(cPos, cPos)
            })
            this.emojiFilter = ""
        },
    },
}
